export const extendHistoryState = (...args) => $.frame.extend_state(...args);
